import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Tooltip.module.css';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

const Tooltip: React.FC<{ text: string }> = ({ text }) => {
    return (
        <div className={styles.tooltip}>
            <FontAwesomeIcon icon={faCircleQuestion} />
            <span>{text}</span>
        </div>
    );
};

export default Tooltip;
